(function () {
  const MOBILE_MAX = 989;

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
  }

  function closeDrawer(headerDrawer) {
    const summary = headerDrawer.querySelector(
      "details[open] > summary.header__icon--menu",
    );
    if (!summary) return;
    summary.click();
  }

  function bindDrawer(headerDrawer) {
    if (headerDrawer.dataset.ceDrawerBound === "true") return;
    headerDrawer.dataset.ceDrawerBound = "true";

    headerDrawer
      .querySelectorAll("[data-ce-header-drawer-close]")
      .forEach((button) => {
        button.addEventListener("click", (event) => {
          if (!isMobile()) return;
          event.preventDefault();
          event.stopPropagation();
          closeDrawer(headerDrawer);
        });
      });

    const overlay = headerDrawer.querySelector(
      "[data-ce-header-drawer-overlay]",
    );
    if (overlay) {
      overlay.addEventListener("click", () => {
        if (!isMobile()) return;
        closeDrawer(headerDrawer);
      });
    }

    headerDrawer.querySelectorAll(".ce-header-drawer__submenu-summary").forEach((summary) => {
      const submenuLink = summary.querySelector(".ce-header-drawer__submenu-link");
      if (!submenuLink) return;

      submenuLink.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    });
  }

  function init(scope = document) {
    scope.querySelectorAll("header-drawer").forEach(bindDrawer);
  }

  init();

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
